import React from "react";
import { Form } from "@redriver/cinnamon";
import { getDepartments } from "./actions";

const DepartmentsDropdown = (props) => (
  <Form.Dropdown {...props} lookupAction={getDepartments} lookupParams={{search:""}}/>
);

export default DepartmentsDropdown;
